/** The header compomemt for desktop view. It:
 * renders header for desktops
 * 
*/

//libraries
import { useNavigate, useLocation } from "react-router-dom";

//styles and images
import { Backdrop, Div, HeaderDivMain, Image, NotificationCounter, SidebarWrapper, Span } from "../../../styles/styles";
import logo from '../../../images/Logo_desktop.svg';
import accountIcon from '../../../images/account-icon-outline.svg';
import notificationIcon from '../../../images/notification-icon-desktop.svg';
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { ensureNamespaces } from "../../../i18n";
import { useSidebar } from "../../../hooks/useSidebar";

import NotificationsSidebar from "../../notifications/notificationSidebar";


const HeaderDesktop = ( {unreadCount} ) => {

    const navigate = useNavigate();
    const location = useLocation();

    const { t } = useTranslation('menu');      
    useEffect(() => { ensureNamespaces(['menu']); }, []);

    const { isOpen, openSidebar, closeSidebar } = useSidebar();

    const openNotifications = () => {
        openSidebar();
    }

    return (        
        <>
            <HeaderDivMain>
                <Div width="auto">
                    <Image src={logo} alt="" />
                </Div>
                <Div row width="auto" gap="30px">
                    <Div row gap="5px" onClick={() => navigate('/account', { state: { returnTo: location.pathname } })} cursor="pointer">
                        <Image src={accountIcon} imgHeight="24px" />
                        <Span fontSize="16px" fontWeight="500">{t('header.account')}</Span>
                    </Div>
                    <Div position="relative" onClick={openNotifications} cursor="pointer">
                        <Image src={notificationIcon} />
                        {unreadCount > 0 && (
                            <NotificationCounter>
                                {unreadCount > 9 ? "9+" : unreadCount}
                            </NotificationCounter>
                        )}
                    </Div>                               
                </Div>
            </HeaderDivMain>

            {isOpen && (
                <>
                    <Backdrop onClick={closeSidebar} />
                    <SidebarWrapper>
                    <NotificationsSidebar onClose={closeSidebar} />
                    </SidebarWrapper>
                </>
                )}


           
        </>
    )
};

export default HeaderDesktop;